import {usePage} from "@inertiajs/react";

export const useIsActiveRoute = () => {
    const {url} = usePage();

    // Извлекаем путь без хеш и GET-параметров
    const currentPath = url.split("?")[0].split("#")[0];

    return (href?: string) => {
        if (!href) return false;

        // Извлекаем путь без хеш и GET-параметров
        const clearHref = href.split("?")[0].split("#")[0];

        if (clearHref === "/") {
            return currentPath === "/";
        }

        // Сравниваем только пути без GET-параметров
        return currentPath === clearHref || currentPath.startsWith(clearHref + "/");
    };
};
